export default {
  gridGap: '0rem 1rem',
  addButtonBg: 'var(--exg-add-button-bg)',
};
